import ModalComponent from "./ModalComponent";
import React from "react";

const SoftwareAuditModal = function ({ showModal, handleClose }) {
  return (
    <ModalComponent
      open={showModal}
      setOpen={handleClose}
      content={
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            alignItems: "center",
            justifyContent: "center",
            background: "#fff",
            padding: "25px",
            borderRadius: "12px",
            maxWidth: "730px",
            margin: "0 auto",
            top: "200px",
          }}
        >
          {/* Close Button */}
          <button
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "none",
              fontSize: "20px",
              fontWeight: "bold",
              cursor: "pointer",
              color: "#444",
            }}
          >
            ×
          </button>

          {/* Right: Text + CTA */}
          <div style={{ flex: "1" }}>
            <h2 className="tc-primary head-font text-center fs-44 pb-5">
              Stop Guessing. Start Building Right
              <br />
              Free AI Audit Report Inside!
            </h2>

            <p className="fs-20 mb-4 text-center text-black">
              Confused by 5 different quotes for the same idea? Get a clear,
              expert-backed roadmap of tech, features, and cost — before you
              spend a single rupee.
            </p>
            <center>
              <button
                onClick={() => {
                  handleClose();
                  window.open("/lm/software-audit", "_blank");
                }}
                className="btn btn-primary w-100"
                style={{
                  background: "#0a2458",
                  border: "none",
                  padding: "12px",
                  fontWeight: "600",
                }}
              >
                Get My Free Audit Report
              </button>
            </center>

            <p className="text-center text-muted small mt-2 mb-0">
              Limited-time deal — report valued at ₹ 999, yours free today.
            </p>
          </div>
        </div>
      }
    />
  );
};

export default SoftwareAuditModal;
